var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.1169C11.8403 11.1169 13.3321 9.62507 13.3321 7.78482C13.3321 5.94457 11.8403 4.45276 10 4.45276C8.15978 4.45276 6.66797 5.94457 6.66797 7.78482C6.66797 9.62507 8.15978 11.1169 10 11.1169Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3892 5.63482C18.097 3.5305 15.1583 0 10 0C4.84175 0 1.90305 3.5305 0.610846 5.63482C-0.203615 6.95241 -0.203615 8.61727 0.610846 9.93486C1.90305 12.0392 4.84175 15.5697 10 15.5697C15.1583 15.5697 18.097 12.0392 19.3892 9.93486C20.2036 8.61727 20.2036 6.95241 19.3892 5.63482ZM10 12.7829C7.23943 12.7829 5.0019 10.545 5.0019 7.78484C5.0019 5.02466 7.23982 2.78675 10 2.78675C12.7602 2.78675 14.9981 5.02466 14.9981 7.78484C14.9954 10.5442 12.759 12.7802 10 12.7829Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.28832e51ff51df575edba1fc0e61c2b1.svg";
export { ForwardRef as ReactComponent };